import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { listMissingReachMixFirebaseClientEnvKeys } from './config/reachMixRequiredClientEnv';
import { ReachMixConfigurationMissingPage } from './components/ReachMixConfigurationMissingPage';

/**
 * ReachMix entry — config gate before Firebase module load (Operator → Reviewer 9, 2026-03-24).
 *
 * If we imported `AuthProvider` / `firebase/index` unconditionally, missing Cloudflare `VITE_*`
 * would still download the JS bundle but could leave `#root` empty after a throw. The gate
 * renders a readable page instead and avoids importing Firebase at all when keys are absent.
 */
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('ReachMix: #root missing from index.html');
}

const missingFirebaseKeys = listMissingReachMixFirebaseClientEnvKeys();

if (missingFirebaseKeys.length > 0) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ReachMixConfigurationMissingPage missingKeys={missingFirebaseKeys} />
    </React.StrictMode>,
  );
} else {
  void import('./AppBootstrap').then(({ mountReachMixApp }) => {
    mountReachMixApp(rootElement);
  });
}
